import React, { useMemo, useState } from 'react';
import { Button, Typography } from '@pinwheel/origami';
import TitleFrame from '../../components/TitleFrame';
import { useOpts } from '../../../context';
import useBankInfo from '../../hooks/useBankInfo';
import { getSubmitPayload } from '../../components/TemplateForm/utils';
import getAmountStringForAllocation from '../../utils/get-amount-string-for-allocation';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
function getLastXChars(str, x) {
    return str.substring(str.length - x);
}
var BankInfoReview = function (_a) {
    var onContinue = _a.onContinue;
    var bankInfoForm = useBankInfo().bankInfoForm;
    var _b = useState(false), submitted = _b[0], setSubmitted = _b[1];
    var getLocalizedString = useGetLocalizedString();
    var _c = useOpts(), amountSelection = _c.amountSelection, linkTokenPayload = _c.linkTokenPayload;
    var amountText = useMemo(function () { return getAmountStringForAllocation(amountSelection, getLocalizedString); }, [amountSelection, getLocalizedString]);
    if (submitted)
        return React.createElement("div", null, "Please wait while we connect you...");
    return (React.createElement(TitleFrame, { title: "Confirm direct deposit", subtitle: "Please review and confirm your changes" },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
            } },
            React.createElement("div", null,
                React.createElement("div", { className: "bankInfoConfirmation-row" },
                    React.createElement("div", null, "Deposit account"),
                    React.createElement(Typography, null,
                        (linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.orgName) || '',
                        " *",
                        getLastXChars(bankInfoForm.accountNumber, 4))),
                React.createElement("div", { className: "bankInfoConfirmation-row" },
                    React.createElement("div", null, "Amount"),
                    React.createElement(Typography, null, amountText))),
            React.createElement(Button, { style: { marginBottom: 18 }, onClick: function () {
                    setSubmitted(true);
                    onContinue(getSubmitPayload(bankInfoForm));
                } }, "Confirm"))));
};
export default BankInfoReview;
